import { render } from "./Inquiry.vue?vue&type=template&id=017cb606&scoped=true"
import script from "./Inquiry.vue?vue&type=script&setup=true&lang=js"
export * from "./Inquiry.vue?vue&type=script&setup=true&lang=js"

import "./Inquiry.vue?vue&type=style&index=0&id=017cb606&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-017cb606"],['__file',"src/views/Inquiry.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "017cb606"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('017cb606', __exports__)) {
    api.reload('017cb606', __exports__)
  }
  
  module.hot.accept("./Inquiry.vue?vue&type=template&id=017cb606&scoped=true", () => {
    api.rerender('017cb606', render)
  })

}


export default __exports__